export enum EnvVariable {
  AUTHORIZATION_TOKEN = 'REACT_APP_AUTHORIZATION_TOKEN',
  SEGMENT_WRITE_KEY = 'REACT_APP_SEGMENT_WRITE_KEY',
  SERVER_HOST = 'REACT_APP_SERVER_HOST',
  TITLE = 'REACT_APP_TITLE',
  USE_CHOOSE_ACTION = 'REACT_APP_USE_CHOOSE_ACTION',
  USE_INVITE_PATIENT = 'REACT_APP_USE_INVITE_PATIENT',
  USE_SEND_MESSAGE = 'REACT_APP_USE_SEND_MESSAGE',
  VERSION = 'REACT_APP_VERSION',
}
